<template>
    <div :style="indent" >
        <div v-show="children.length" class="treeExpander" style="cursor: pointer" @click="doExpand">{{ isExpanded ? ' - ' : ' + ' }}</div>
        <div v-show="!children.length" class="treeExpander">&nbsp;</div>
        <input ref="cb" type="checkbox" @click="clicked" :checked="isSelected"/>
        <div class="treeNode left5"><span class="has-text-coolGreen"><b>::</b></span>{{listName}}</div>
        <tree v-show="isExpanded" class="top2" v-for="(item, ind) in children" :key="ind" :listName="item.listName" :children="item.children" :depth="depth + 1" :id="item.id">
        </tree>
    </div>
</template>

<script>
    import { AZEventBus } from './AZEventBus'

    export default { 
        name: 'tree',
        props: ['listName', 'children', 'depth', 'id'],
        data: function(){
            return {
                isSelected: true,
                isExpanded: true
            }
        },
        mounted(){
            let bundle = this.$root.app.bundles.find(e => {
                return e.id == this.id
            })
        },
        methods: {
            clicked: function(){
                let msg = {};
                msg.id = this.id
                if(this.$refs.cb.checked == true){
                    msg.selected = true
                } else {
                    msg.selected = false
                }
                AZEventBus.$emit('onShareTreeClicked', msg)
            },
            doExpand: function(){
                this.isExpanded = !this.isExpanded
            }
        },
        computed: {
            indent() {
                return this.depth == 0 ? '' : { transform: 'translate(30px)' }
            }
        }
    }
</script>